import { Trigger, ModalDialog, Heading, Paragraph, Flex, Text, FONT_TYPES, TriggerText } from '@zillow/constellation';
import { event } from '@zillow/universal-analytics';
import React from 'react';
import PropTypes from 'prop-types';

var LegalPopover = function LegalPopover(_ref) {
  var text = _ref.text,
    triggerText = _ref.triggerText,
    interactionEventCmsInfo = _ref.interactionEventCmsInfo,
    className = _ref.className,
    style = _ref.style;
  var onOpenInteractionEvent = interactionEventCmsInfo ? {
    envelope: {
      event_type_id: '5030',
      event_type_version_id: '1',
      event_template_id: '297',
      event_template_version_id: '1'
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'cms',
      trigger_source_nm: 'cms_modal',
      trigger_object_nm: 'no_trigger_object'
    },
    semantic: {
      semantic_event_nm: 'cms_open'
    },
    cms_info: interactionEventCmsInfo
  } : null;
  var onCloseInteractionEvent = interactionEventCmsInfo ? {
    envelope: {
      event_type_id: '2051',
      event_type_version_id: '1',
      event_template_id: '126',
      event_template_version_id: '1'
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'cms',
      trigger_source_nm: 'cms_modal',
      trigger_object_nm: 'no_trigger_object'
    },
    semantic: {
      semantic_event_nm: 'cms_close'
    },
    cms_info: interactionEventCmsInfo
  } : '';
  return /*#__PURE__*/React.createElement(Trigger, {
    triggered: /*#__PURE__*/React.createElement(ModalDialog, {
      wide: true,
      header: /*#__PURE__*/React.createElement(Heading, {
        level: 2
      }, "Calculator Disclaimer"),
      body: /*#__PURE__*/React.createElement(Paragraph, null, text)
    }),
    onOpen: function onOpen() {
      return event(onOpenInteractionEvent);
    },
    onClose: function onClose() {
      return event(onCloseInteractionEvent);
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    marginY: "sm",
    display: "flex",
    justifyContent: "flex-end",
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: FONT_TYPES.bodySmall
  }, /*#__PURE__*/React.createElement(TriggerText, null, triggerText))));
};
LegalPopover.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string,
  triggerText: PropTypes.string,
  interactionEventCmsInfo: PropTypes.object,
  className: PropTypes.string
} : {};
var LegalPopover$1 = LegalPopover;

export { LegalPopover$1 as default };
